import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import Home from './views/Home.vue'
import Preregister from './views/pre-register.vue'
import TermsOfService from './views/terms_of_service.vue'
import PrivacyPolicy from './views/privacy_policy.vue'
import countDown from './pages/home/countDown'
import Clue3 from './views/clue3.vue'
import News from './views/News.vue'
import NewsDetail from './views/NewsDetail.vue'

Vue.use(Router)

// lazy-loaded
function loadView(path) {
	return () =>
		import(/* webpackChunkName: "view-[request]" */ `${path}`)
}

const router = new Router({
	mode: process.env.NODE_ENV === 'production' ? 'history' : 'hash',
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home,
		},
		{
			path: '/news',
			name: 'news',
			component: News,
		},
		{
			path: '/news/:newsid',
			name: 'newsDetail',
			component: NewsDetail,
		},
		{
			path: '/pre-register',
			name: 'pre-register',
			component: Preregister,
		},
		{
			path: '/clue3',
			name: 'clue3',
			component: Clue3,
		},
		{
			path: '/terms_of_service',
			name: 'terms_of_service',
			component: TermsOfService,
		},
		{
			path: '/privacy_policy',
			name: 'privacy_policy',
			component: PrivacyPolicy,
		},
		{
			path: '/countDown',
			name: 'countDown',
			component: countDown,
        },
        {
			path: '/fankit',
			name: 'fankit',
            component: loadView("./views/Fankit.vue"),
            children: [
                {
                    path: "/",
                    name: "FankitIndex",
                    component: loadView("./pages/fankit/index.vue"),
                },
                {
                    path: "precautions",
                    name: 'Precautions',
                    component: loadView("./pages/fankit/Precautions.vue"),
                },
                {
                    path: "guidelines",
                    name: "Guidelines",
                    component: loadView("./pages/fankit/Guidelines.vue"),
                }
            ]
		},
	],
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	},
})

router.beforeEach(async (to, from, next) => {
	if (from.name === 'home' && to.name !== null) {
        // 离开首页
		if (store.state.HOME_FULLPAGE) {
			store.state.HOME_FULLPAGE.fullScrollDisable(true)
			store.state.HOME_FULLPAGE.bodyScrollable(true)
		}
	}
	next()
})

export default router
